import script from "./ArchivedPage.vue?vue&type=script&setup=true&lang=js"
export * from "./ArchivedPage.vue?vue&type=script&setup=true&lang=js"

import "./ArchivedPage.vue?vue&type=style&index=0&id=6aa84626&lang=scss"

const __exports__ = script;

export default __exports__